import { ApiService } from "pwapi";

import { LIS } from "shared/actions/constants";
import { AsyncSagaAction, createAsyncSaga } from "shared/utils/asyncActions";

export const ACCESSION_CASE_REQUEST = "@@api/ACCESSION_CASE_REQUEST";
export const ACCESSION_CASE_SUCCESS = "@@api/ACCESSION_CASE_SUCCESS";
export const ACCESSION_CASE_FAILURE = "@@api/ACCESSION_CASE_FAILURE";

type GetArgs = Parameters<typeof ApiService.retrieveCaseWithWork>[0];
export const getCase = createAsyncSaga(
  LIS.CASE.GET.REQUEST,
  LIS.CASE.GET.SUCCESS,
  LIS.CASE.GET.ERROR,
  (args: GetArgs) => `case/${args.id}`,
  ApiService.retrieveCaseWithWork
) as AsyncSagaAction<GetArgs>;

type GetModMedArgs = Parameters<typeof ApiService.modmedCaseWithWork>[0];
export const getModMedCase = createAsyncSaga(
  LIS.MODMED_CASE.GET.REQUEST,
  LIS.MODMED_CASE.GET.SUCCESS,
  LIS.MODMED_CASE.GET.ERROR,
  (args: GetModMedArgs) => `modmed-case/${args.externalOrderId}`,
  ApiService.modmedCaseWithWork
) as AsyncSagaAction<GetModMedArgs>;

type ListArgs = Parameters<typeof ApiService.listCaseWithWorks>[0];
export const listCases = createAsyncSaga(
  LIS.CASE.LIST.REQUEST,
  LIS.CASE.LIST.SUCCESS,
  LIS.CASE.LIST.ERROR,
  (args: ListArgs) => {
    return `lis/cases/${args.parentLookupLabStationId}}`;
  },
  (args: ListArgs) => {
    return ApiService.listCaseWithWorks({
      ...args,
      limit: args.limit ?? 99999,
    });
  }
) as AsyncSagaAction<ListArgs>;

type AccessionCaseArgs = Parameters<typeof ApiService.accessionCase>[0];
export const accessionCase = createAsyncSaga(
  ACCESSION_CASE_REQUEST,
  ACCESSION_CASE_SUCCESS,
  ACCESSION_CASE_FAILURE,
  (args: AccessionCaseArgs) => `case/${args.id}/accession`,
  ApiService.accessionCase
) as AsyncSagaAction<AccessionCaseArgs>;
